import "./css/style.css"
import loaderImage from "./assets/loader.gif";

export default function AntosLoadingScreen() {
    return (
        <div id={"antos-loading-screen"}>
            <img alt={"loader"} src={loaderImage} className={"loader-gif"}/>
        </div>
    );
}
